import { loadOrders } from "./orders";

const STORAGE_KEY = "almoune_payments_ledger";

export const getPayments = () => {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error("Error reading payments:", err);
    return [];
  }
};

export const savePayments = (payments) => {
  if (typeof window === "undefined") return payments;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payments));
  return payments;
};

export const createPayment = (params) => {
  const payments = getPayments();
  const existing = payments.find((p) => p.id === params.id);
  if (existing) return existing;

  const newPayment = {
    id: params.id || `pay_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
    orderId: params.orderId,
    amount: Number(params.amount || 0),
    method: params.method || "CASH", // CASH, CARD, CHEQUE, TRANSFER
    date: params.date || new Date().toISOString(),
    reference: params.reference || "",
    status: params.status || "CLEARED", // PENDING, CLEARED, FAILED, CANCELLED, REFUNDED
  };
  
  payments.push(newPayment);
  savePayments(payments);
  return newPayment;
};

export const updatePaymentStatus = (paymentId, status) => {
  const payments = getPayments();
  const index = payments.findIndex(p => p.id === paymentId);
  if (index === -1) return null;

  payments[index].status = status;
  savePayments(payments);
  return payments[index];
};

export const getOrderFinancials = (order) => {
  if (!order) return { totalAmount: 0, paidAmount: 0, remainingAmount: 0, paymentStatus: "NOT_FOUND", allPayments: [] };

  const totalAmount = Number(order.amount || 0);

  // Get all cleared payments for this order
  const allPayments = getPayments();
  const orderPayments = allPayments.filter(p => p.orderId === order.id);
  
  const paidAmount = orderPayments
    .filter(p => p.status === "CLEARED")
    .reduce((sum, p) => sum + Number(p.amount), 0);
    
  const remainingAmount = Math.max(0, totalAmount - paidAmount);
  
  let paymentStatus = "En attente"; // Default
  if (paidAmount > 0) {
    if (paidAmount >= totalAmount) {
      paymentStatus = "Payee";
    } else {
      paymentStatus = "Partiellement payée";
    }
  }

  return {
    totalAmount,
    paidAmount,
    remainingAmount,
    paymentStatus,
    allPayments: orderPayments
  };
};
